export default __webpack_public_path__ + "static/media/claira react.685ee7c1.png";